import { render, staticRenderFns } from "./MessagePlainTextBody.vue?vue&type=template&id=2b087d35&scoped=true"
import script from "./MessagePlainTextBody.vue?vue&type=script&lang=js"
export * from "./MessagePlainTextBody.vue?vue&type=script&lang=js"
import style0 from "./MessagePlainTextBody.vue?vue&type=style&index=0&id=2b087d35&prod&lang=scss"
import style1 from "./MessagePlainTextBody.vue?vue&type=style&index=1&id=2b087d35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b087d35",
  null
  
)

export default component.exports